import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchCatalogSearch } from 'b2b-apps/shop/catalog/redux/search/actionCreators';

export type UseFetchResultActionReturnType = typeof fetchCatalogSearch;
export function useFetchCatalogSearchAction(): UseFetchResultActionReturnType {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(fetchCatalogSearch, dispatch), [
    dispatch,
  ]);
}
